let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8mkTm")).then(() => parcelRequire('2slRW'));